<template>
  <div id="exhibitor">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'exhibitor'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhibitor/Product.vue